import React from "react";
import type { ChildrenProps } from "../../types";

/** Props Interface */
interface ActivityChartWeekCellProps extends ChildrenProps {}

export function ActivityChartWeekCell({ children }: ActivityChartWeekCellProps) {
	/** Render */
	return (
		<React.Fragment>
			<div className="flex flex-col gap-0 activity-chart-week-column">{children}</div>
		</React.Fragment>
	);
}
